import React from 'react';
import { useLang } from '../context/LanguageContext';
import { t } from '../translations';

const About = () => {
  const { lang } = useLang();
  const tx = t[lang];

  return (
    <section className="mt-6 bg-white border border-zinc-200 rounded-lg p-6 md:p-8">
      <h2 className="text-lg font-bold text-zinc-900 mb-4">{tx.aboutTitle}</h2>
      <p className="text-zinc-700 leading-relaxed mb-3" dangerouslySetInnerHTML={{ __html: tx.aboutP1 }} />
      <p className="text-zinc-700 leading-relaxed mb-3">
        {tx.aboutP2}{' '}
        <a href="https://vr.prospera.com.ar/" className="underline underline-offset-2 hover:text-zinc-500" target="_blank" rel="noreferrer">
          Narra VR
        </a>,{' '}
        <a href="https://stlpremium.com/" className="underline underline-offset-2 hover:text-zinc-500" target="_blank" rel="noreferrer">
          STL Premium
        </a>{' '}
        {tx.and}{' '}
        <a href="https://customradarchart.com/" className="underline underline-offset-2 hover:text-zinc-500" target="_blank" rel="noreferrer">
          Custom Radar Chart
        </a>.
      </p>
      <p className="text-zinc-700 leading-relaxed" dangerouslySetInnerHTML={{ __html: tx.aboutP3 }} />
    </section>
  );
};

export default About;
